import { createSlice } from '@reduxjs/toolkit';

interface ProfileState {
  data: {
    name: string;
    lastName?: string;
    avatar?: string;
    username?: string;
    email?: string;
    phoneNumber?: string;
    workspaceId?: string;
  };
}

const initialState: ProfileState = {
  data: {
    name: '',
    lastName: '',
    avatar: '',
    username: '',
    email: '',
    phoneNumber: '',
    workspaceId: '',
  },
};

const profileSlice = createSlice({
  name: 'profile',
  initialState,
  reducers: {
    setProfile: (state, action) => {
      state.data = action.payload.data;
    },
  },
});

export const { setProfile } = profileSlice.actions;
export { profileSlice };
